import { render, staticRenderFns } from "./Downloading.vue?vue&type=template&id=2b5d3450&scoped=true&"
import script from "./Downloading.vue?vue&type=script&lang=js&"
export * from "./Downloading.vue?vue&type=script&lang=js&"
import style0 from "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css?vue&type=style&index=0&id=2b5d3450&lang=css&scoped=true&"
import style1 from "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css?vue&type=style&index=1&id=2b5d3450&lang=css&scoped=true&"
import style2 from "@/styles/toolbar.css?vue&type=style&index=2&id=2b5d3450&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d3450",
  null
  
)

export default component.exports